import { cn } from '../lib/utils';

const PALETTE = {
  healthy: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  watchlist: 'bg-blue-50 text-blue-700 border-blue-200',
  maintenance: 'bg-amber-50 text-amber-800 border-amber-200',
  warning: 'bg-amber-50 text-amber-800 border-amber-200',
  critical: 'bg-red-50 text-red-700 border-red-200',
  offline: 'bg-slate-100 text-slate-600 border-slate-200',
  informational: 'bg-slate-100 text-slate-700 border-slate-200',
  info: 'bg-blue-50 text-blue-700 border-blue-200',
  running: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  idle: 'bg-slate-100 text-slate-600 border-slate-200',
  fan: 'bg-blue-50 text-blue-700 border-blue-200',
  aux: 'bg-amber-50 text-amber-800 border-amber-200',
  error: 'bg-red-50 text-red-700 border-red-200',
  online: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  new: 'bg-blue-50 text-blue-700 border-blue-200',
  reviewed: 'bg-slate-100 text-slate-700 border-slate-200',
  scheduled: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  assigned: 'bg-violet-50 text-violet-700 border-violet-200',
  in_progress: 'bg-amber-50 text-amber-800 border-amber-200',
  waiting_parts: 'bg-orange-50 text-orange-800 border-orange-200',
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  cancelled: 'bg-slate-100 text-slate-500 border-slate-200',
  resolved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  dismissed: 'bg-slate-100 text-slate-500 border-slate-200',
  normal: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  watch: 'bg-blue-50 text-blue-700 border-blue-200',
};

const LABEL = {
  in_progress: 'In Progress',
  waiting_parts: 'Waiting on Parts',
};

export default function StatusBadge({ status, children, className, testId }) {
  const key = String(status || '').toLowerCase();
  const cls = PALETTE[key] || 'bg-slate-100 text-slate-700 border-slate-200';
  const label = children || LABEL[key] || (key.charAt(0).toUpperCase() + key.slice(1));
  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium',
        cls,
        className
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full',
        key === 'healthy' || key === 'running' || key === 'online' || key === 'completed' || key === 'resolved' || key === 'normal' ? 'bg-emerald-500'
        : key === 'critical' || key === 'error' ? 'bg-red-500'
        : key === 'warning' || key === 'maintenance' || key === 'in_progress' || key === 'aux' ? 'bg-amber-500'
        : key === 'waiting_parts' ? 'bg-orange-500'
        : key === 'offline' || key === 'cancelled' || key === 'dismissed' || key === 'idle' || key === 'reviewed' ? 'bg-slate-400'
        : key === 'scheduled' ? 'bg-indigo-500'
        : key === 'assigned' ? 'bg-violet-500'
        : 'bg-blue-500'
      )} />
      {label}
    </span>
  );
}
